import { FC } from 'react'
import MLVisaCardImage from '../MLVisaCardImage'
import { P2, P3 } from '../../compass-ui'
import { CardArtAssetName } from '../../types'
import getCardArtFromList from './ProductDisplaySection.utils'

interface ProductDisplaySectionProps {
  shortName: string
  cardArtList?: CardArtAssetName[]
  variant?: 'default' | 'inPage'
}

const ProductDisplaySection: FC<ProductDisplaySectionProps> = ({
  shortName,
  cardArtList,
  variant = 'default',
}) => {
  const { combinedCardArt, hasMultiple } = getCardArtFromList(cardArtList)

  const primaryColor = variant === 'inPage' ? 'text-ink-800' : 'text-white'
  const secondaryColor = variant === 'inPage' ? 'text-ink-600' : 'text-green-300'

  const getProductName = () =>
    shortName.toLowerCase() === 'visa' ? (
      <div data-testid="card-product-name-single">
        <P2 color={primaryColor}>
          <b>
            Mission Lane Visa<sup>®</sup>
          </b>
        </P2>
        <P3 color={secondaryColor}>Credit Card</P3>
      </div>
    ) : (
      <div data-testid="card-product-name-single">
        <P3 color={secondaryColor}>Mission Lane</P3>
        <P2 color={primaryColor}>
          <b>
            {shortName}
            <sup>®</sup>
          </b>
        </P2>
        <P3 color={secondaryColor}>Credit Card</P3>
      </div>
    )

  return (
    <div data-testid="product-display-section">
      {hasMultiple ? (
        <div className="flex flex-col">
          <P3 className="ml-[4%]" color={primaryColor} data-testid="card-product-name-multiple">
            <b>
              Mission Lane Visa<sup>®</sup> Credit Cards
            </b>
          </P3>
          <div
            className={`relative ${
              combinedCardArt === 'gold-silver-green' ? 'aspect-[2.707]' : 'aspect-[2.578]'
            }`}
          >
            <MLVisaCardImage cardArt={combinedCardArt} fill hideShadow />
          </div>
        </div>
      ) : (
        <div className="flex flex-row gap-4 items-center">
          <div className="relative aspect-[1.588] min-w-[113px] md:min-w-[144px]">
            <MLVisaCardImage cardArt={combinedCardArt} fill />
          </div>
          {getProductName()}
        </div>
      )}
    </div>
  )
}

export default ProductDisplaySection
